export default class OrderBy {
    static DESC = "DESC";
    static ASC = "ASC";
}